import React, { useState } from 'react';
import './style/TopNavbar.css';
import StudyOption from '../AllData/HomeData';
import { Link, useLocation } from 'react-router-dom';
import AboutApp from '../AllData/AboutApp';
import BackPhone from './Backphone';


const NavigationButton = (props) => {
    const [leftMenuOpen, setLeftMenuOpen] = useState(false);
    const [rightMenuOpen, setRightMenuOpen] = useState(false);
    const location = useLocation();

    const studyOptions = StudyOption;

    const activeOptions = studyOptions.filter(option => option.status === "true");

    const userName = localStorage.getItem('userName');


    var name = userName ? `Hi  ${userName}` : "Welcome To NEET Prep App";

    const handleLeftMenuClick = () => {
        setLeftMenuOpen(!leftMenuOpen);
        if (rightMenuOpen) setRightMenuOpen(false);

        if (props.onLeftMenuClick) {
            props.onLeftMenuClick(!leftMenuOpen);
        }
    };

    const handleRightMenuClick = () => {
        setRightMenuOpen(!rightMenuOpen);
        if (leftMenuOpen) setLeftMenuOpen(false);

        if (props.onRightMenuClick) {
            props.onRightMenuClick(!rightMenuOpen);
        }
    };

    const closeAllMenus = () => {
        setLeftMenuOpen(false);
        setRightMenuOpen(false);
    };

    const appLink = 'https://play.google.com/store/apps/details?id=com.mystudyplace.neetmocktest';

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: AboutApp[0].name,
                    text: '',
                    url: appLink,
                });

                console.log('Shared successfully');
            } catch (error) {
                console.log('Error sharing:', error);
            }
        } else if (window.Android && window.Android.shareLink) {
            // CALL THE NATIVE ANDROID FUNCTION
            window.Android.shareLink(appLink);
        }
    };

    // Don't render navbar on desktop devices
    if (window.innerWidth > 1150) {
        return null;
    }



    if (location.pathname !== '/') {
        return null;
    }

    return (
        <>
            {/* Backdrop overlay when menu is open */}
            {(leftMenuOpen || rightMenuOpen) && (
                <div
                    className="menu-backdrop"
                    onClick={closeAllMenus}
                ></div>
            )}



            <div className="top-navbar-mobile">
                {/* Left side - 3 line menu */}
                <div className="navbar-left" onClick={handleLeftMenuClick}>
                    <div className={`menu-icon ${leftMenuOpen ? 'active' : ''}`}>
                        <span className="menu-line"></span>
                        <span className="menu-line"></span>
                        <span className="menu-line"></span>
                    </div>
                    <div className='welcome-text'> <h4> {name}</h4></div>
                </div>





                <Link to="/more-options">
                    <div className="navbar-right" >
                        <div className="dot-menu">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </div>
                    </div>
                </Link>

                <BackPhone />

                {/* Right Menu Dropdown */}
                {rightMenuOpen && (
                    <div className="menu-dropdown right-menu">
                        <div className="menu-header">
                            <h3>Options</h3>
                        </div>
                        <ul className="menu-links">

                            <li className="menu-link-item">

                            </li>
                        </ul>
                    </div>
                )}
            </div>

            {/* Left Sidebar Menu - Slides from left */}
            <div className={`sidebar-menu ${leftMenuOpen ? 'sidebar-open' : ''}`}>
                <div className="sidebar-header">
                    <div className="sidebar-user-info">
                        <div className="user-avatar"><Link to="/">
                            <img src="/logo.png" style={{ height: "40px", width: "40px", marginTop: "20px" }} className="logo" alt="Study Logo" />
                        </Link>
                        </div>
                        <div className="user-details">
                            <h3>NEET Prep App</h3>
                        </div>
                    </div>
                    <button className="sidebar-close" onClick={closeAllMenus}>
                        ×
                    </button>
                </div>

                <div className="sidebar-content">

                    <ul className="sidebar-links">

                        <li className="sidebar-link-item">
                            <button onClick={handleShare} className="sidebar-link-button" >
                                <span className="link-icon">⬆️</span>
                                <span className='link-label'>Share this app</span>
                            </button>
                        </li>

                        <li className="sidebar-link-item">
                            <Link to="/" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">🏠</span>
                                <span className="link-label">Home</span>
                            </Link>
                        </li>

                        <li className="sidebar-link-item">
                            <Link to="/profile" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">👤</span>
                                <span className="link-label">Profile</span>
                            </Link>
                        </li>





                        {/* Dynamic study options */}
                        {activeOptions.map((option) => (
                            <li key={option.id} className="sidebar-link-item">
                                <Link
                                    to={option.link}
                                    className="sidebar-link-button"
                                    onClick={closeAllMenus}
                                >
                                    <span className="link-icon" style={{ fontSize: '20px' }}>
                                        {option.symbol}
                                    </span>
                                    <span className="link-label">{option.name}</span>
                                </Link>
                            </li>
                        ))}

                        {/* Additional static links */}
                        <li className="sidebar-link-item">
                            <Link to="/about" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">👥</span>
                                <span className="link-label">About Us</span>
                            </Link>
                        </li>

                        <li className="sidebar-link-item">
                            <Link to="/contact" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">☎️</span>
                                <span className="link-label">Contact Us</span>
                            </Link>
                        </li>

                        <li className="sidebar-link-item">
                            <Link to="/privacy-policy" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">🛡️</span>
                                <span className="link-label">Privacy Policy</span>
                            </Link>
                        </li>
                        <li className="sidebar-link-item">
                            <Link to="/refund-policy" className="sidebar-link-button" onClick={closeAllMenus}>
                                <span className="link-icon">💳</span>
                                <span className="link-label">Refund Policy</span>
                            </Link>
                        </li>


                    </ul>

                </div>


                <div className="sidebar-footer">
                    <Link to="/">
                        <img src="/logo.png" className="logo" alt="Study Logo" />
                    </Link>
                    <h4>NEET Prep App</h4>

                </div>

            </div>

            <br></br>

        </>
    );
};

export default NavigationButton;